module.exports = __webpack_public_path__ + "static/media/capture_session_04.b8f8ad95.png";